import { render, staticRenderFns } from "./groupSend.vue?vue&type=template&id=182e042c"
import script from "./groupSend.vue?vue&type=script&lang=js"
export * from "./groupSend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports